import { Box } from "@mui/material";
import AzureKeyVaultResourceDetailsView from "./AzureKeyVaultResourceDetailsView";

const AzureKeyVaultSecretDetailsView = ({ entityData }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <AzureKeyVaultResourceDetailsView entityData={entityData} />
    </Box>
  );
};

export default AzureKeyVaultSecretDetailsView;
